export const classificationDefaultValues = ["P1", "IIP Veg"];
